module.exports = __webpack_public_path__ + "static/media/tw.5490b142.svg";